export const FIXED_PAGE_TITLES = {
  about: 'About Me',
  contact: 'Contact Me',
  gallery: 'Gallery',
  documents: 'Documents',
  bookings: 'Bookings',
  lessons: 'Music Lessons'
};

export const enforceFixedPageTitles = (content) => {
  const next = JSON.parse(JSON.stringify(content));

  Object.entries(FIXED_PAGE_TITLES).forEach(([page, title]) => {
    if (!next[page] || typeof next[page] !== 'object') {
      next[page] = {};
    }
    next[page].pageTitle = title;
  });

  return next;
};
